import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials so the admin_token httpOnly cookie is sent on protected routes.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fmt = (n) => {
  if (n >= 1_000_000_000) return (n / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return String(n);
};

/** Secret URL suffix for the admin dashboard (Option B). */
export const VAULT_PATH = "/vault-x9k3m7q2";
